import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import { track } from "./lib/api";

import Home from "./pages/Home";
import ThankYou, { ThankYouState, ThankYouApplication } from "./pages/ThankYou";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Privacy, Terms } from "./pages/Legal";
import { AdminLogin, AuthCallback } from "./pages/AdminAuth";
import AdminDashboard from "./pages/AdminDashboard";
import Apply from "./pages/Apply";
import Training from "./pages/Training";
import FleetHealthAssessment from "./pages/FleetHealthAssessment";
import FleetHealthResults from "./pages/FleetHealthResults";
import NotFound from "./pages/NotFound";

const SCORECARD = "/fleet-crossroads-scorecard";
const RESULTS = "/fleet-crossroads-results";

// Legacy offers, pricing and payment pages are retired from the public site.
const RETIRED = [
  "/fleet-clarity-kit", "/clarity-check", "/clarity-check/result", "/growth-track",
  "/diagnostic", "/diagnostic/checkout", "/backend-buildout", "/webinar", "/pathway",
  "/resources", "/pay/diagnostic", "/payment/success", "/payment/cancel",
  "/thank-you/growth-track", "/thank-you/diagnostic",
];

function RedirectKeepQuery({ to }) {
  const loc = useLocation();
  return <Navigate to={`${to}${loc.search}`} replace />;
}

function PageTracker() {
  const loc = useLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { window.scrollTo(0, 0); track("page_view", loc.pathname); }, [loc.pathname]);
  return null;
}

function AppRouter() {
  const loc = useLocation();
  if (loc.hash && loc.hash.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <PageTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path={SCORECARD} element={<FleetHealthAssessment />} />
        <Route path={RESULTS} element={<FleetHealthResults />} />
        <Route path="/fleet-health-assessment" element={<RedirectKeepQuery to={SCORECARD} />} />
        <Route path="/fleet-health-results" element={<RedirectKeepQuery to={RESULTS} />} />
        <Route path="/training" element={<Training />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/thank-you/application" element={<ThankYouApplication />} />
        <Route path="/thank-you/:state" element={<ThankYouState />} />
        {RETIRED.map(p => <Route key={p} path={p} element={<Navigate to="/" replace />} />)}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal/privacy" element={<Privacy />} />
        <Route path="/legal/terms" element={<Terms />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (<BrowserRouter><AppRouter /></BrowserRouter>);
}
